import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe(
	'pk_test_51KHk7tFzNhWvYBelIZpOZNHr6yLTqRXhduGnH6PLVHSPBgPQho2lmBHHgrMzT1tjllbUxiI3d9Cd4SsGHSI50vcd00jg7p758h',
);
